import React from "react";
import { isMobile } from "../../utils/utils";

 
interface Step {
  title: string;
  description: string;
}
 
interface SubscriptionProgressbarComponentProps {
  steps: Step[];
  current: number; 
}
 
export default function SubscriptionProgressbarComponent ({ steps, current }: SubscriptionProgressbarComponentProps) {

return (
  <div className="stepper-row">
      {steps?.map((step, idx) => (
        <div className="stepper-step" key={idx}>
          <div className={`stepper-circle ${idx === current ? "active" : "inactive"}`}>
            {idx + 1}
          </div>

          <div className={`stepper-content ${idx === current ? "active" : "inactive"}`}>
            <div className="stepper-title">{isMobile() && `Etape ${idx + 1}: `}{step.title}</div>
            {/* <div className="stepper-desc">{step.description}</div> */}
          </div>
          {idx < steps.length - 1 && (<div className="stepper-line" />)}
        </div>
      ))}
  </div>
)};